var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7861 8.84565H20.9V8.8H11V13.2H17.2167C16.3097 15.7614 13.8727 17.6 11 17.6C7.35515 17.6 4.4 14.6448 4.4 11C4.4 7.35515 7.35515 4.4 11 4.4C12.6825 4.4 14.2131 5.0347 15.3786 6.07145L18.4899 2.9601C16.5253 1.12915 13.8974 0 11 0C4.92525 0 0 4.92525 0 11C0 17.0748 4.92525 22 11 22C17.0748 22 22 17.0748 22 11C22 10.2625 21.9241 9.5425 21.7861 8.84565Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26855 5.88005L4.8826 8.5305C5.8605 6.1094 8.2288 4.4 11.0003 4.4C12.6827 4.4 14.2134 5.0347 15.3788 6.07145L18.4902 2.9601C16.5256 1.12915 13.8977 0 11.0003 0C6.77515 0 3.11105 2.38535 1.26855 5.88005Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 21.9998C13.8411 21.9998 16.4228 20.9124 18.3747 19.1442L14.9702 16.2633C13.8287 17.1314 12.4339 17.6009 10.9998 17.5998C8.13868 17.5998 5.70933 15.7754 4.79413 13.2295L1.20703 15.9932C3.02753 19.5556 6.72463 21.9998 10.9998 21.9998Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.786 8.8457H20.9V8.80005H11V13.2H17.2167C16.7828 14.4191 16.0013 15.4843 14.9688 16.2641L14.9704 16.263L18.375 19.1439C18.1341 19.3628 22 16.5 22 11C22 10.2625 21.9241 9.54255 21.786 8.8457Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a12e666d154859f12078d8ce4314fdb9.svg";
export { ForwardRef as ReactComponent };